// ---- utilitaires ----
function handleFormSubmit(formTarget) {
  formTarget.addEventListener('submit', async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const button = form.querySelector('button[type="submit"]');

    button?.classList.add('loading');

    try {
      const response = await fetch(form.action, {
        method: form.method,
        body: new FormData(form),
      });
      const data = await response.json();

      if (data.success) {
        showToast('form-validation', data.message, 'success');
        form.reset();
      } else {
        showToast('form-validation', data.message, 'danger');
      }
    } catch (err) {
        showToast('form-validation', 'Une erreur est survenue, veuillez réessayer.', 'danger');
    } finally {
      button?.classList.remove('loading');
    }
  });
}

// ---- formulaires ----
document.addEventListener('DOMContentLoaded', function () {
  const newsletterSubscriber = document.querySelector('#subscribeContactForm');
  if (newsletterSubscriber) handleFormSubmit(newsletterSubscriber);

  const formContact = document.querySelector('#formContactForm');
  if (formContact) handleFormSubmit(formContact);
});